import { Injectable, ErrorHandler } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../environments/environment";

import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://89626b78b3bb447fb11532c17f954c96@o423135.ingest.sentry.io/5352906",
  // TryCatch has to be configured to disable XMLHttpRequest wrapping, as we are going to handle
  // http module exceptions manually in Angular's ErrorHandler and we don't want it to capture the same error twice.
  // Please note that TryCatch configuration requires at least @sentry/browser v5.16.0.
  environment: environment.production
    ? "LIVE"
    : environment.local
    ? "LOCAL"
    : environment.staging
    ? "STAGING"
    : "DEV",
  integrations: [
    new Sentry.Integrations.TryCatch({
      XMLHttpRequest: false,
    }),
  ],
});

@Injectable()
export class SentryErrorService implements ErrorHandler {
  constructor() {}

  extractError(error) {
    // Try to unwrap zone.js error.
    // https://github.com/angular/angular/blob/master/packages/core/src/util/errors.ts
    if (error && error.originalError) {
      error = error.originalError;
    }

    // We can handle messages and Error objects directly.
    if (typeof error === "string" || error instanceof Error) {
      return error;
    }

    // If it's http module error, extract as much information from it as we can.
    if (error instanceof HttpErrorResponse) {
      // The `error` property of http exception can be either an `Error` object, which we can use directly...
      if (error.error instanceof Error) {
        return error.error;
      }

      // ... or an`ErrorEvent`, which can provide us with the message but no stack...
      if (error.error instanceof ErrorEvent) {
        return error.error.message;
      }

      // ...or the request body itself, which we can use as a message instead.
      if (typeof error.error === "string") {
        return `Server returned code ${error.status} with body "${error.error}"`;
      }

      // If we don't have any detailed information, fallback to the request message itself.
      return error.message;
    }

    // Skip if there's no error, and let user decide what to do with it.
    return null;
  }

  handleError(error) {
    console.log(`raw error:`);
    console.log(error);

    if (error.originalError) {
      console.log(error.originalError);
    }

    const extractedError = this.extractError(error) || "Handled unknown error";

    // When in development mode, log the error to console for immediate feedback.

    // Capture handled exception and send it to Sentry.

    Sentry.captureException(extractedError);
  }
}
